  <template>
    <div :class="{'page_content--loading': !reportData}">
      <div class="vx-row justify-end">
        <div class="vx-col">
          <DateRanges
            :start-day="startDay"
            :end-day="endDay"
            @on-change="onDateChange"
          />
        </div>
      </div>
      <div class="vx-row justify-end">
        <div class="vx-col">
          <switch-field
            v-model="innerFiltered"
            class="mt-4 mb-4"
            name="フィルター表示"
            label="フィルター表示"
          />
        </div>
      </div>
      <div
        v-if="showFilters"
        class="vx-row justify-end"
      >
        <div
          style="z-index: 9998;"
          class="vx-col"
        >
          <div class="filter">
            <sales-filter
              v-model="selectedAdtype"
              class="w-48 mb-1 mr-1"
              :options="AdtypeOptions"
              :no-option-text="costByAdtypeFilterNoOptionText"
              placeholder="タイプ"
            />
            <sales-filter
              v-model="selectedPortfolioName"
              class="w-48 mb-1 mr-1"
              :options="PortfolioNameOptions"
              :no-option-text="costByPortfolioNameFilterNoOptionText"
              placeholder="ポートフォリオ"
            />
            <sales-filter
              v-model="selectedCampaign"
              class="w-48 mb-1 mr-1"
              :options="CampaignOptions"
              :no-option-text="costByCampaignFilterNoOptionText"
              placeholder="キャンペーン"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-1/2">
          <vx-card>
            <monthly-cost-by-adtype-chart
              :class="{'min-h-full': !reportData}"
              :report="reportData.monthlyCostByAdtype"
              :height="400"
            />
          </vx-card>
        </div>
        <div class="vx-col w-1/2">
          <vx-card>
            <monthly-n-cpa-chart
              :class="{'min-h-full': !reportData}"
              :report="reportData.monthlyNCpa"
              :height="400"
            />
          </vx-card>
        </div>
      </div>

      <div
        v-if="reportData"
      >
        <div class="mt-8">
          <vx-card class="pb-6">
            <template #actions>
              <vs-button
                @click="onClickDownload('summaryByPortfolio')"
              >
                CSVエクスポート
              </vs-button>
            </template>
            <data-table
              :row-data="reportData.summaryByPortfolio"
              :column-defs="tableProp.summaryByPortfolio.columnDefs"
              :default-col-def="tableProp.summaryByPortfolio.defaultColDef"
            >
            </data-table>
          </vx-card>
        </div>

        <div class="mt-8">
          <vx-card>
            <template #actions>
              <vs-button
                @click="onClickDownload('monthlySummary')"
              >
                CSVエクスポート
              </vs-button>
            </template>
            <data-table
              :row-data="reportData.monthlySummary"
              :column-defs="tableProp.monthlySummary.columnDefs"
              :default-col-def="tableProp.monthlySummary.defaultColDef"
              style="height: 640px"
            >
            </data-table>
          </vx-card>
        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import DataTable from '@/components/table/DataTable'
  import DateRanges from '@/components/DateRanges'
  import SalesFilter from '@/components/SalesFilter'
  import MonthlyCostByAdtypeChart from '@/user/components/charts/MonthlyCostByAdtypeChart'
  import MonthlyNCpaChart from '@/user/components/charts/MonthlyNCpaChart'
  import SwitchField from '@/components/fields/SwitchField'
  import { debounce } from '@/utils'
  
  export default {
    components: {
      DataTable,
      DateRanges,
      SalesFilter,
      SwitchField,
      MonthlyCostByAdtypeChart,
      MonthlyNCpaChart
    },
    data () {
      return {
        // フィルター
        selectedAdtype: [],
        selectedPortfolioName: [],
        selectedCampaign: [],
        filtered: false,
        showFilters: false,
        // 表のプロパティ
        tableProp: {
          summaryByPortfolio: {
            defaultColDef: {
              sortable: false,
              editable: false,
              resizable: true,
              suppressMenu: true
            },
            columnDefs: [
              { headerName: 'タイプ', field: 'adtype', width: 120, pinned: 'left' },
              { headerName: 'ポートフォリオ', field: 'portfolioName', width: 135, pinned: 'left' },
              { headerName: 'キャンペーン', field: 'campaign', pinned: 'left' },
              { headerName: '広告グループ', field: 'lineItem', pinned: 'left' },
              { headerName: '広告費', field: 'cost', currency: true },
              { headerName: '新規率', field: 'ntbRate', percent: true },
              { headerName: '売上', field: 'totalProductSales', currency: true },
              { headerName: 'ROAS', field: 'roas', percent: true },
              { headerName: 'NTB売上', field: 'ntbSales', currency: true },
              { headerName: 'N-ROAS', field: 'nRoas', percent: true },
              { headerName: '販売数', field: 'totalUnitsSold' },
              { headerName: 'CPA', field: 'cpa', currency: true },
              { headerName: 'NTB販売数', field: 'ntbTotalUnitsSold' },
              { headerName: 'N-CPA', field: 'nCpa', currency: true },
              { headerName: 'NTBユーザー数', field: 'ntbUsers' },
              { headerName: 'LTV売上', field: 'ltvSales', currency: true },
              { headerName: 'ARPU', field: 'arpu', currency: true },
              { headerName: 'ARPU-ACOS', field: 'arpuAcos', percent: true }
            ],
            gridOptions: {},
          },
          monthlySummary: {
            defaultColDef: {
              sortable: false,
              editable: false,
              resizable: true,
              suppressMenu: true
            },
            columnDefs: [
              { headerName: '月', field: 'costMonth', width: 135, pinned: 'left' },
              { headerName: '広告費', field: 'cost', currency: true },
              { headerName: '新規率', field: 'ntbRate', percent: true },
              { headerName: '売上', field: 'totalProductSales', currency: true },
              { headerName: 'ROAS', field: 'roas', percent: true },
              { headerName: 'NTB売上', field: 'ntbSales', currency: true },
              { headerName: 'N-ROAS', field: 'nRoas', percent: true },
              { headerName: '販売数', field: 'totalUnitsSold' },
              { headerName: 'CPA', field: 'cpa', currency: true },
              { headerName: 'NTB販売数', field: 'ntbTotalUnitsSold' },
              { headerName: 'N-CPA', field: 'nCpa', currency: true },
              { headerName: 'NTBユーザー数', field: 'ntbUsers' },
              { headerName: 'LTV売上', field: 'ltvSales', currency: true },
              { headerName: 'ARPU', field: 'arpu', currency: true },
              { headerName: 'ARPU-ACOS', field: 'arpuAcos', percent: true }
            ],
            gridOptions: {},
          },
        },
        // APIのactionとパラメータの対応
        apiParameters: {
          monthlyCostByAdtype: ['filters'],
          monthlyNCpa: ['filters'],
          summaryByPortfolio: ['start_day', 'end_day', 'filters'],
          monthlySummary: ['filters'],
          costByAdtype: ['start_day', 'end_day'],
          costByPortfolioName: ['start_day', 'end_day'],
          costByCampaign: ['start_day', 'end_day']
        }
      }
    },
    computed: {
      ...mapState(['startDay', 'endDay']),
      ...mapState('amcAdCampaign', ['requestingStatus', 'reportData', 'filterOptions']),
      ...mapState('account', ['activeAccount']),
      costByAdtypeFilterNoOptionText () {
        return this.requestingStatus.costByAdtype ? 'Loading...' : '候補がありません'
      },
      costByPortfolioNameFilterNoOptionText () {
        return this.requestingStatus.costByPortfolioName ? 'Loading...' : '候補がありません'
      },
      costByCampaignFilterNoOptionText () {
        return this.requestingStatus.costByCampaign ? 'Loading...' : '候補がありません'
      },
      CampaignOptions () {
        if (!this.reportData) {
          return []
        }
        return this.reportData.costByCampaign.map(item => ({
          text: item.campaign,
          value: item.campaign,
          sales: item.cost
        }))
      },
      PortfolioNameOptions () {
        if (!this.reportData) {
          return []
        }
        return this.reportData.costByPortfolioName.map(item => ({
          text: item.portfolioName,
          value: item.portfolioName,
          sales: item.cost
        }))
      },
      AdtypeOptions () {
        if (!this.reportData) {
          return []
        }
        return this.reportData.costByAdtype.map(item => ({
          text: item.adtype,
          value: item.adtype,
          sales: item.cost
        }))
      },
      selectedCampaignValues () {
        return this.selectedCampaign.map(selectedCampaign => selectedCampaign.value)
      },
      selectedAdtypeValues () {
        return this.selectedAdtype.map(selectedAdtype => selectedAdtype.value)
      },
      selectedPortfolioNameValues () {
        return this.selectedPortfolioName.map(selectedPortfolioName => selectedPortfolioName.value)
      },
      innerFiltered: {
        get () {
          return this.filtered
        },
        set (val) {
          this.filtered = val
          this.showFilters = val
        }
      },
    },
    watch: {
      selectedAdtype: {
        handler () {
          this.filterReport()
        },
        deep: true
      },
      selectedPortfolioName: {
        handler () {
          this.filterReport()
        },
        deep: true
      },
      selectedCampaign: {
        handler () {
          this.filterReport()
        },
        deep: true
      },
      activeAccount: {
        handler () {
          this.resetFilters()
        }
      }
    },
    created () {
      // 先月を指定
      this.$store.commit('SET_STARTDAY', moment().subtract(1, 'month').startOf('month').format())
      this.$store.commit('SET_ENDDAY',  moment().subtract(1, 'month').endOf('month').format())
  
      this.getReport()
    },
    methods: {
      ...mapActions('amcAdCampaign', ['fetchReport', 'downloadCSV']),
      resetFilters () {
        this.selectedAdtype = []
        this.selectedPortfolioName = []
        this.selectedCampaign = []
      },
      onDateChange (date) {
        this.$store.commit('SET_STARTDAY', moment(date.start).format())
        this.$store.commit('SET_ENDDAY',  moment(date.end).format())
        this.getReport()
      },
      omitDupFormatter(params) {
        // セルの値が上段と一致した場合、表示を抑制するフォーマッター
        const { node, colDef, data, value, api } = params;
        if (node.rowIndex > 0) {
          const dataAbove = api.getDisplayedRowAtIndex(node.rowIndex - 1)['data']
          if(dataAbove[colDef.field] === data[colDef.field]) {
            return ''
          }
        }
        return value
      },
      generateParams (paramKeys) {
        const params = {}
        if ( paramKeys.includes('start_day') && paramKeys.includes('end_day') ) {
          params['start_day'] = this.startDay.split('T')[0]
          params['end_day'] = this.endDay.split('T')[0]
        }
        if ( paramKeys.includes('filters') ) {
          if (this.selectedAdtypeValues) {
            params['adtype'] = this.selectedAdtypeValues
          }
          if (this.selectedPortfolioNameValues) {
            params['portfolio_name'] = this.selectedPortfolioNameValues
          }
          if (this.selectedCampaignValues) {
            params['campaign'] = this.selectedCampaignValues
          }
        }
        return params
      },
      async onClickDownload (action) {
        const params = this.generateParams(this.apiParameters[action])
        try {
          await this.downloadCSV({...params, action})
        } catch (e) {
          console.log(e)
        }
      },
      filterReport: debounce(function () {
        this.getReport()
      }, 1000),
      async getReport () {
        const actions = [
          'monthlyCostByAdtype',
          'monthlyNCpa',
          'summaryByPortfolio',
          'monthlySummary',
          'costByAdtype',
          'costByPortfolioName',
          'costByCampaign',
        ]
  
        await Promise.all(actions.map(action => {
          return new Promise((resolve) => {
            try {
              resolve(this.fetchReport({
                ...this.generateParams(this.apiParameters[action]),
                action
              }))
            } catch (e) {
              console.log(e)
            }
          })
        }))
      }
    }
  }
  </script>
  
  <style lang="scss">  
  .page_content--loading .vx-card {
    min-height: 127.875px;
  }
  
  .text-nowrap {
    text-wrap: nowrap;
  }
  </style>
  
  <style>
  .holamundo :deep(.vs-popup) {
    width: 400px;
  }
  div.filter {
      display: flex;
      flex-wrap: wrap;
  }
  .sales-filter .multiselect__tags,
  .sales-filter .multiselect__tags .multiselect__input,
  .sales-filter .multiselect__content-wrapper {
    font-size: 13px;
  }
  </style>
  